module.exports = __webpack_public_path__ + "img/buy-icon2.25a59bf.png";